const form = document.querySelector("#registrationForm");
const box_model = document.querySelector("#box-model");
const box_model_userNameExits = document.querySelector("#box-model-userNameExits");
const ok_button = document.querySelectorAll(".ok-button");
const close_box = document.querySelectorAll(".close-box");
const dropdown_btn = document.querySelector("#dropbtn");
const body = document.querySelector("body");


/* Bank Variables*/
const bankListContainer = document.querySelector(".dropdown-bank");
const backName = document.querySelector("#backName");
const dropdown = document.querySelector("#myDropdown");
const dropdown_input = document.querySelector("#myInput");
const bankVal = document.querySelector("#bankValidation");

/* Role Variables*/
const roleListContainer = document.querySelector(".dropdown-role");
const roleName = document.querySelector("#roleName");
const dropdown_role = document.querySelector("#myDropdown-role");
const dropdown_btn_role = document.querySelector("#dropbtn-role");


/* Input Variables*/
const firstname = document.querySelector("#firstname");
const lastname = document.querySelector("#lastname");
const email = document.querySelector("#email");
const emailVal = document.querySelector("#emailValidation");
const emailEmptyVal = document.querySelector("#emailEmptyValidation");
const firstnameVal = document.querySelector("#firstnameValidation");
const lastnameVal = document.querySelector("#lastnameValidation");



let institution  = "";
let role  = "MA_SALES_MANAGEMENT";

/* Bank Options Click Event*/
const dropdown_bankOptions = document.querySelectorAll(".bank-option");
for (let i = 0; i < dropdown_bankOptions.length; i++) {
    dropdown_bankOptions[i].addEventListener('click', function () {
        bankVal.classList.remove('validationShow');
        institution = this.dataset.value;
        backName.innerText = dropdown_bankOptions[i].textContent || dropdown_bankOptions[i].innerText;
        dropdown.classList.remove('listShow');
        document.getElementById("myInput").value = '';
        for (let j = 0; j < dropdown_bankOptions.length; j++) {
            dropdown_bankOptions[j].style.display = "";
        }
    })
}

/* Role Options Click Event*/
const dropdown_roleOptions = document.querySelectorAll(".role-option");
for (let i = 0; i < dropdown_roleOptions.length; i++) {
    dropdown_roleOptions[i].addEventListener('click', function () {
        role = this.dataset.value
        roleName.innerText = dropdown_roleOptions[i].textContent || dropdown_roleOptions[i].innerText;
        dropdown_role.classList.remove('listShow');
    })
}


/* Input Event -> Validation hide*/
firstname.addEventListener('input', function () {
    firstnameVal.classList.remove('validationShow');
})
lastname.addEventListener('input', function () {
    lastnameVal.classList.remove('validationShow');
})
email.addEventListener('input', function () {
    emailVal.classList.remove('validationShow');
    emailEmptyVal.classList.remove('validationShow');
})

/* Bank-Name-Button Click Event*/
dropdown_btn.addEventListener('click', function (e) {
    dropdown.classList.toggle('listShow')
})

/* Role-Name-Button Click Event*/
dropdown_btn_role.addEventListener('click', function (e) {
    dropdown_role.classList.toggle('listShow')
})

/* Search in Bank-List Event*/
dropdown_input.addEventListener('keyup', filterFunction)

function filterFunction() {
    let input, filter, a, txtValue, i;
    input = document.getElementById("myInput");
    filter = input.value.toUpperCase();
    if (filter === '') {
        backName.innerText = "Bitte wählen";
        institution = "";
        for (i = 0; i < dropdown_bankOptions.length; i++) {
            dropdown_bankOptions[i].style.display = "";
        }
    } else {
        for (i = 0; i < dropdown_bankOptions.length; i++) {
            txtValue = dropdown_bankOptions[i].textContent || dropdown_bankOptions[i].innerText;
            if (txtValue.toUpperCase().indexOf(filter) > -1) {
                dropdown_bankOptions[i].style.display = "";
            } else {
                dropdown_bankOptions[i].style.display = "none";
            }
        }
    }
}

/* Validation Function*/
function isValidEmailRegex(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

function validation(formDataObject) {

    let allowSubmit = true;
    let dataValue = "";
    for (const key of formDataObject.keys()) {
        switch (key) {
            case 'email':
                if (formDataObject.get('email').trim() !== '' && !isValidEmailRegex(formDataObject.get('email').trim())) {
                    allowSubmit = false;
                    emailVal.classList.add('validationShow');
                } else {
                    emailVal.classList.remove('validationShow');
                }
                if (formDataObject.get('email').trim() === '') {
                    emailEmptyVal.classList.add('validationShow');
                    allowSubmit = false;
                } else {
                    emailEmptyVal.classList.remove('validationShow');
                }
                break;
            case 'firstname':
                if (formDataObject.get('firstname').trim() === '') {
                    firstnameVal.classList.add('validationShow');
                    allowSubmit = false;
                } else {
                    firstnameVal.classList.remove('validationShow');
                }
                break;
            case 'lastname':
                if (formDataObject.get('lastname').trim() === '') {

                    lastnameVal.classList.add('validationShow');
                    allowSubmit = false;
                } else {
                    lastnameVal.classList.remove('validationShow');
                }
                break;

            case 'institution':
                if (formDataObject.get('institution') === '') {
                    bankVal.classList.add('validationShow');
                    allowSubmit = false
                } else {
                    bankVal.classList.remove('validationShow');
                }
                break;
            default:
                dataValue = "";
                break;
        }
    }


    return allowSubmit
}

/* Form Submit Event*/
function onSubmit(event) {
    const formData = new FormData(event.target);
    formData.append('institution', institution);
    formData.append('role', role);

    if (!validation(formData))
        return

    emailVal.classList.remove('validationShow');
    firstnameVal.classList.remove('validationShow');
    lastnameVal.classList.remove('validationShow');
    bankVal.classList.remove('validationShow');

    let response;
    if (typeof AwsWafIntegration !== 'undefined') {
        response = AwsWafIntegration.fetch("/registrierung/", {
            method: "POST",
            body: new URLSearchParams(formData)
        });
    } else {
        response = fetch("/registrierung/", {
            method: "POST",
            body: new URLSearchParams(formData)
        });
    }
    response.then(response => {
        switch (response.status) {
            case 202:
                window.location.replace("/registrierung/registrierung-erfolgreich");
                break;
            case 204:
                window.location.replace("/registrierung/freigabe-ausstehend");
                break;
            case 409:
                box_model_userNameExits.classList.add('show');
                break;
            case 400:
            case 500:
                box_model.classList.add('show');
                break;
            default:
                break;
        }
    });
}

if (close_box && ok_button) {

    close_box.forEach((item) => {

        item.addEventListener("click", closeBox);
    });
    ok_button.forEach((item) => {
        item.addEventListener("click", closeBox);
    });

}

function closeBox() {

    box_model.classList.remove('show');
    box_model_userNameExits.classList.remove('show');
}

form.addEventListener("submit", (event) => {
    event.preventDefault();

    onSubmit(event);
});

/* Body Click Event*/
body.addEventListener('click', function (e) {
    const clickInBankList = e.target.classList.contains('dropdown-bank') || bankListContainer.contains(e.target)
    const clickInRoleList = e.target.classList.contains('dropdown-role') || roleListContainer.contains(e.target)
    if (!clickInBankList) {
        dropdown.classList.remove('listShow');
    }
    if (!clickInRoleList) {
        dropdown_role.classList.remove('listShow');
    }
})